import $ from 'jquery';
import cart from '@ppcp/cart';
import {getSetting} from '@ppcp/utils';
import {ExpressCheckoutController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import PayPalGateway from '../gateways/PayPalGateway';

const settings = getSetting('ppcp_data');

const gateway = new PayPalGateway({
    id: 'ppcp',
    cart,
    settings
});

const context = new Context('express_checkout');

const controller = new ExpressCheckoutController({
    id: 'ppcp',
    cart,
    context,
    gateway,
    settings
});

controller.initialize();